import { FormControlLabel, Radio } from '@mui/material';
// SCSS
import styles from "./index.module.scss";
import RadioFillIcon from "../../../Assets/images/radio-fill.svg";
import RadioIcon from "../../../Assets/images/radio-outline.svg";
const RadioBoxLabel = ({
  label,
  type,
  value,
  selectedValue,
  submitStatus,
  required,
  disabled,
  onChange,
  labelClass,
}) => {
  return (
    <FormControlLabel
      label={label}
      className={`RadioLabelButtonStyle ${selectedValue === value ? "is-checked" : ""}`}
      disabled={disabled}
      control={
        <Radio
          checked={selectedValue === value}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          icon={<img src={RadioIcon} alt={label} />}
          checkedIcon={<img src={RadioFillIcon} alt={label} />}
          className={`${styles.radioClass}`}
		  type={type}
        />
      }
    />
  );
};

export default RadioBoxLabel;
